import { ComponentClassNames } from '../../util/classNames';
import { getGutterValue } from '../../util/styles/gutters';
import { getRTL, memoizeFunction, mergeStyleSets } from '../../util/styling';

type GetClassNamesMemoized = (
  columnSpacing: number,
  bottomSpacing: number | undefined,
  className: GetClassNamesProps['className'],
  isRTLCacheBuster: boolean
) => FixedGridRowClassNames;
const getClassNamesMemoized: GetClassNamesMemoized = memoizeFunction((columnSpacing, bottomSpacing, className) =>
  mergeStyleSets({
    fixedGridRow: [
      {
        display: 'flex',
        marginBottom: bottomSpacing ? getGutterValue(bottomSpacing) : undefined,
        selectors: {
          '> .y-fixedGridColumn': {
            marginLeft: getGutterValue(columnSpacing),
            selectors: {
              ':first-child': {
                marginLeft: 0,
              },
            },
          },
        },
      },
      className,
    ],
  })
);

type FixedGridRowClassNames = ComponentClassNames<'fixedGridRow'>;
interface GetClassNamesProps {
  readonly columnSpacing: number;
  readonly bottomSpacing: number | undefined;
  readonly className: string | undefined;
}
type GetClassNames = (props: GetClassNamesProps) => FixedGridRowClassNames;
export const getClassNames: GetClassNames = ({ columnSpacing, bottomSpacing, className }) =>
  getClassNamesMemoized(columnSpacing, bottomSpacing, className, getRTL());
